import React, { useState } from 'react';
import Chatbot from './ChatbotComp'
import DashboardHeader from '../components/mainDashboard/DashboardHeader'
import './PIDashboard.scss';
import NotificationChat from '../components/supportDashboard/NotificationChat';
import { getChatsList } from '../api/chatbotAPI';
import { useQuery } from 'react-query';
import Loader from '../components/ui/Loader';


const SupportPage = ()=>{
    
    const chatsQuery = useQuery({
		queryKey: ['chats-list'],
		queryFn: getChatsList,
		staleTime: 3000000, //5 minutes to refetch
        refetchInterval: 10000, // Refetch every 10 seconds
	});
    if(chatsQuery.isLoading){
       return <Loader/>
    }
    const { newChats } = chatsQuery.data.data;
    return(
        <div className='dashboard-general-wrapper'> 
            <div className='dashboard-content-container'>
				<h2>Active conversations</h2>

                <NotificationChat data={newChats}/>

            </div>
        </div>
    )  
};
export default SupportPage;